var _style, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWithName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "100px",
    viewBox: "0 0 800 400",
    style: {
      enableBackground: "new 0 0 800 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000181061730616425947760000009928976895777593533_);}\n\t.st2{fill:url(#SVGID_00000008134282147995513330000010729644853450625178_);}\n\t.st3{fill:url(#SVGID_00000006693391701921068420000002991157866145888950_);}\n\t.st4{fill:#F7D293;}\n\t.st5{fill:none;}\n\t.st6{fill:#F7D490;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -1107.9823,
    cy: 720.3707,
    r: 116.5028,
    fx: -1109.348,
    fy: 719.2499,
    gradientTransform: "matrix(-7.802230e-02 -0.997 -0.983 7.693379e-02 781.4256 -951.0664)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3347,
    style: {
      stopColor: "#FAF1D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5052,
    style: {
      stopColor: "#FAEFD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    style: {
      stopColor: "#F9EAC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7952,
    style: {
      stopColor: "#F8E2B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9304,
    style: {
      stopColor: "#F7D79F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9827,
    style: {
      stopColor: "#F7D293"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.7,190.2c0,0-0.9-34.4-0.9-49.3c0-14.1,3.5-31.7,6.2-40.5s10.6-35.2,23.8-38.8c13.2-3.5,15.9,2.6,17.6,5.3 c2.6,2.6,8.8,7,18.5,35.2c8.8,28.2,9.7,38.8,9.7,49.3c-0.9,9.7-6.2,22-11.5,28.2c-5.3,6.2-9.7,11.5-9.7,11.5s11.5-0.9,21.1,0 c9.7,0.9,34.4,6.2,37.9,15.9s1.8,18.5-4.4,27.3c-6.2,8.8-15.9,19.4-26.4,25.6c-10.6,6.2-15.9,5.3-19.4,4.4 c-3.5-0.9-10.6-3.5-12.3-5.3c-2.6-1.8-5.3-5.3-5.3-5.3s-3.5-16.7-7-25.6c-4.4-10.6-6.2-14.1-11.5-22 C176.3,197.3,157.7,190.2,157.7,190.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000008848301994085807820000008561661766283929279_",
    cx: 153.0477,
    cy: 196.3339,
    r: 119.9304,
    fx: 161.7868,
    fy: 214.9495,
    gradientTransform: "matrix(1 0 0 -1 0 402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08119511,
    style: {
      stopColor: "#FAF1D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4733,
    style: {
      stopColor: "#FAF0D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6326,
    style: {
      stopColor: "#F9EDCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7497,
    style: {
      stopColor: "#F9E8C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8461,
    style: {
      stopColor: "#F8DFB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    style: {
      stopColor: "#F6D59B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    style: {
      stopColor: "#F7D293"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008848301994085807820000008561661766283929279_)"
    },
    d: "M123.4,254.6c0,0-12.3,6.2-22,7.9 S52.9,266,37.9,259c-15-7-25.6-17.6-22-32.6c3.5-15,11.5-18.5,19.4-20.3c7.9-1.8,37-5.3,62.6-2.6c25.6,2.6,48.5,7,67.8,30 s20.3,32.6,19.4,42.3c-0.9,9.7-8.8,22-19.4,27.3c-10.6,5.3-26.4,6.2-36.1,1.8c-9.7-4.4-16.7-15-15.9-26.4 C114.6,266.9,123.4,254.6,123.4,254.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162345321956145833070000004290790870592054416_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.0076,
    y1: 191.5503,
    x2: 224.6977,
    y2: 114.2048,
    gradientTransform: "matrix(1 0 0 -1 0 402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#FAF1D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#FAEFD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4578,
    style: {
      stopColor: "#F9E8C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6498,
    style: {
      stopColor: "#F8DEAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8226,
    style: {
      stopColor: "#F7D293"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162345321956145833070000004290790870592054416_)"
    },
    d: "M132.2,190.2c2.6-2.6,5.3-2.6,9.7-1.8 c4.4,0.9,26.4,10.6,36.1,23.8c9.7,13.2,16.7,25.6,19.4,40.5c2.6,15,4.4,28.2,4.4,28.2h-2.6c0,0-4.4-10.6-10.6-24.7 c-5.3-10.6-20.3-31.7-27.3-37.9c-16.7-12.3-24.7-9.7-27.3-12.3c-2.6-2.6-4.4-9.7-4.4-11.5C129.6,192,132.2,190.2,132.2,190.2z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000059307979353384625070000005562546257818334603_",
    cx: 153.0477,
    cy: 196.3339,
    r: 55.2723,
    gradientTransform: "matrix(1 0 0 -1 0 402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3025,
    style: {
      stopColor: "#FAF1D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    style: {
      stopColor: "#F7D293"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000059307979353384625070000005562546257818334603_)"
    },
    cx: 114.6,
    cy: 182.3,
    r: 11.5
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97,175.3c0,0-9.7-12.3-15-15.9c-5.3-3.5-12.3-3.5-15-2.6c-2.6,0.9-7,4.4-4.4,8.8c2.6,4.4,5.3,4.4,8.8,2.6 c3.5-0.9,5.3-1.8,7.9-0.9c2.6,0.9,15.9,9.7,15.9,9.7L97,175.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M103.1,168.2c0,0-12.3-10.6-14.1-15c-1.8-5.3-5.3-14.1-1.8-17.6c4.4-3.5,6.2-2.6,9.7,0c3.5,2.6,0,9.7,0,13.2 c0,3.5,0.9,7,3.5,9.7s4.4,7.9,4.4,7.9L103.1,168.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 371.2,
    y: 64.8,
    className: "st5",
    width: 693.8,
    height: 274.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M415.1,119.5c-2.3,1.2-7.4,2.4-13.8,2.4c-17,0-27.3-10.6-27.3-26.9c0-17.6,12.2-28.2,28.5-28.2 c6.4,0,11,1.3,13,2.4l-2.1,7.8c-2.5-1.1-6-2.1-10.5-2.1c-10.9,0-18.7,6.8-18.7,19.7c0,11.7,6.9,19.3,18.6,19.3c4,0,8.1-0.8,10.6-2 L415.1,119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M468.8,93.8c0,17.9-10.9,28.2-25.6,28.2c-15.1,0-24.6-11.5-24.6-27.2c0-16.4,10.3-28,25.4-28 C459.6,66.8,468.8,78.6,468.8,93.8z M428.9,94.6c0,10.9,5.5,19.5,14.8,19.5c9.4,0,14.7-8.7,14.7-19.9c0-10.1-5-19.6-14.7-19.6 C434.1,74.6,428.9,83.6,428.9,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M485.3,75.8h-15.2v-8.2h40.4v8.2H495v45.3h-9.8V75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M515.8,110.5c3.2,1.8,7.9,3.4,12.9,3.4c6.3,0,9.8-2.9,9.8-7.3c0-4-2.7-6.4-9.5-8.9 c-8.8-3.2-14.4-7.9-14.4-15.5c0-8.7,7.3-15.4,18.9-15.4c5.8,0,10.1,1.3,12.8,2.7l-2.4,7.9c-1.9-1-5.6-2.5-10.6-2.5 c-6.2,0-8.9,3.3-8.9,6.4c0,4.1,3.1,6,10.2,8.8c9.3,3.5,13.8,8.2,13.8,15.9c0,8.6-6.5,16-20.3,16c-5.6,0-11.5-1.6-14.4-3.3 L515.8,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M565.9,121.1l-13.1-53.4h10.4l5.1,24.3c1.3,6.5,2.6,13.3,3.5,18.6h0.2c0.9-5.6,2.4-12,3.9-18.7l5.8-24.2h10.2 l5.3,24.6c1.3,6.3,2.5,12.3,3.3,18.1h0.2c1-5.9,2.2-12,3.6-18.5l5.6-24.2h9.9l-14.4,53.4h-10.5l-5.6-25.1c-1.3-6.1-2.3-11.2-2.9-17 h-0.2c-1,5.7-2,10.9-3.6,17l-6.2,25.1H565.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M673.2,93.8c0,17.9-10.9,28.2-25.6,28.2c-15.1,0-24.6-11.5-24.6-27.2c0-16.4,10.3-28,25.4-28 C664,66.8,673.2,78.6,673.2,93.8z M633.3,94.6c0,10.9,5.5,19.5,14.8,19.5c9.4,0,14.7-8.7,14.7-19.9c0-10.1-5-19.6-14.7-19.6 C638.4,74.6,633.3,83.6,633.3,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M681.6,67.6h9.8v45.3h22v8.2h-31.7V67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M720.7,68.4c4.3-0.7,9.8-1.1,15.5-1.1c10,0,16.9,2.1,21.8,6.2c5.2,4.2,8.3,10.5,8.3,19.7 c0,9.5-3.3,16.7-8.3,21.3c-5.3,4.8-13.8,7.3-24.2,7.3c-5.7,0-10-0.3-13.2-0.7V68.4z M730.4,113.6c1.3,0.2,3.4,0.2,5.4,0.2 c12.7,0.1,20.2-6.9,20.2-20.5c0.1-11.8-6.7-18.6-19-18.6c-3.1,0-5.3,0.2-6.7,0.6V113.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M415.1,214.7c-2.3,1.2-7.4,2.4-13.8,2.4c-17,0-27.3-10.6-27.3-26.9c0-17.6,12.2-28.2,28.5-28.2 c6.4,0,11,1.3,13,2.4l-2.1,7.8c-2.5-1.1-6-2.1-10.5-2.1c-10.9,0-18.7,6.8-18.7,19.7c0,11.7,6.9,19.3,18.6,19.3c4,0,8.1-0.8,10.6-2 L415.1,214.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M468.8,189c0,17.9-10.9,28.2-25.6,28.2c-15.1,0-24.6-11.5-24.6-27.2c0-16.4,10.3-28,25.4-28 C459.6,161.9,468.8,173.7,468.8,189z M428.9,189.8c0,10.9,5.5,19.5,14.8,19.5c9.4,0,14.7-8.7,14.7-19.9c0-10.1-5-19.6-14.7-19.6 C434.1,169.8,428.9,178.7,428.9,189.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M486.7,201.1l-4.6,15.1H472l17.1-53.4h12.5l17.4,53.4h-10.5l-4.8-15.1H486.7z M502,193.7l-4.2-13.2 c-1-3.3-1.9-6.9-2.7-10H495c-0.8,3.1-1.6,6.8-2.5,10l-4.1,13.2H502z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M563.1,214.7c-2.3,1.2-7.4,2.4-13.8,2.4c-17,0-27.3-10.6-27.3-26.9c0-17.6,12.2-28.2,28.5-28.2 c6.4,0,11,1.3,13,2.4l-2.1,7.8c-2.5-1.1-6-2.1-10.5-2.1c-10.9,0-18.7,6.8-18.7,19.7c0,11.7,6.9,19.3,18.6,19.3c4,0,8.1-0.8,10.6-2 L563.1,214.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M581.2,162.8v21.4h22.6v-21.4h9.8v53.4h-9.8v-23.6h-22.6v23.6h-9.8v-53.4H581.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M634.5,162.8v53.4h-9.8v-53.4H634.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M645.6,216.2v-53.4h11.1l13.8,22.9c3.6,5.9,6.7,12.1,9.1,17.9h0.2c-0.6-7.1-0.9-14-0.9-22.2v-18.6h9v53.4 h-10.1l-14-23.5c-3.4-5.9-7-12.5-9.6-18.5l-0.2,0.1c0.4,6.9,0.5,14,0.5,22.8v19.1H645.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M742.1,213.8c-3.4,1.3-10.1,3-17.2,3c-9,0-15.9-2.3-20.9-7.1c-4.8-4.5-7.5-11.6-7.5-19.7 c0-16.9,12.1-27.8,29.7-27.8c6.6,0,11.7,1.3,14.2,2.5l-2.1,7.9c-2.9-1.3-6.5-2.3-12.1-2.3c-11.4,0-19.4,6.7-19.4,19.2 c0,12.1,7.5,19.3,18.6,19.3c3.5,0,6.1-0.5,7.4-1.1v-13.3h-9.4v-7.7h18.9V213.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M415.1,309.8c-2.3,1.2-7.4,2.4-13.8,2.4c-17,0-27.3-10.6-27.3-26.9c0-17.6,12.2-28.2,28.5-28.2 c6.4,0,11,1.3,13,2.4l-2.1,7.8c-2.5-1.1-6-2.1-10.5-2.1c-10.9,0-18.7,6.8-18.7,19.7c0,11.7,6.9,19.3,18.6,19.3c4,0,8.1-0.8,10.6-2 L415.1,309.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M423.4,258h9.8v45.3h22v8.2h-31.7V258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M472.3,258v53.4h-9.8V258H472.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M483.5,311.4V258h11.1l13.8,22.9c3.6,5.9,6.7,12.1,9.1,17.9h0.2c-0.6-7.1-0.9-14-0.9-22.2V258h9v53.4h-10.1 l-14-23.5c-3.4-5.9-7-12.5-9.6-18.5l-0.2,0.1c0.4,6.9,0.5,14,0.5,22.8v19.1H483.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M546.8,258v53.4h-9.8V258H546.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M596.3,309.8c-2.3,1.2-7.4,2.4-13.8,2.4c-17,0-27.3-10.6-27.3-26.9c0-17.6,12.2-28.2,28.5-28.2 c6.4,0,11,1.3,13,2.4l-2.1,7.8c-2.5-1.1-6-2.1-10.5-2.1c-10.9,0-18.7,6.8-18.7,19.7c0,11.7,6.9,19.3,18.6,19.3c4,0,8.1-0.8,10.6-2 L596.3,309.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithName);
export default __webpack_public_path__ + "static/media/logo-with-name.9dfbefc89e70ef422db46562f7a5c87b.svg";
export { ForwardRef as ReactComponent };